import React, { useState } from 'react'
import styled from "styled-components";
import PropTypes from "prop-types"


const StyledCheckBoxMonogramm = styled.div`
    padding: 20px;
`

const CheckBoxMonogramm = ({ onOpened }) => {

    const [isOpened, setIsOpened] = useState(false);

    const handleClickOpened = async (e) => {
        e.preventDefault();
        setIsOpened(!isOpened)
        if (onOpened) {
            onOpened(isOpened)
        }
    }

    return (
        <StyledCheckBoxMonogramm>
            <button onClick={handleClickOpened}>
                Добавить вышивку
            </button>
            {isOpened &&
                <div>
                    Открыто
                </div>
            }
        </StyledCheckBoxMonogramm>
    )
}

CheckBoxMonogramm.propTypes = {
    title: PropTypes.string,
    hideLine: PropTypes.bool
};

export default CheckBoxMonogramm;